import {
  Activity,
  ActivityValue,
  FlatActivityModel,
  NestableGroupValue
} from 'types/shared'
import { DefaultValueResolver } from './helpers'
import { primitiveResolver } from './primitiveResolver'
import { otpResolver } from './otpResolver'
import {
  uniSelectionResolver,
  multiSelectionResolver
} from './selectionResolver'
import {
  autocompleteUniResolver,
  autocompleteMultiResolver
} from './autocompleteResolver'

const defaultValueResolvers: Partial<
  Record<FlatActivityModel['content_type'], DefaultValueResolver>
> = {
  string: primitiveResolver,
  integer: primitiveResolver,
  textarea: primitiveResolver,
  one_time_password: otpResolver,
  explicit_uniselection_objectclass: uniSelectionResolver,
  explicit_multiselection_objectclass: multiSelectionResolver,
  explicit_uniselection_accordion: uniSelectionResolver,
  explicit_multiselection_accordion: multiSelectionResolver,
  standard_uniselection: uniSelectionResolver,
  standard_multiselection: multiSelectionResolver,
  autocomplete_uniselection: autocompleteUniResolver,
  autocomplete_multiselection: autocompleteMultiResolver
}

export function resolveActivity(
  activityModel: FlatActivityModel,
  _activityValues: Record<string, ActivityValue | NestableGroupValue>
): Promise<Activity | null> | null {
  const model = activityModel

  const filteractionUuid = model.default_value_filteraction
  if (!filteractionUuid) return null

  const resolver = defaultValueResolvers[activityModel.content_type]
  if (!resolver) return null

  return resolver(activityModel, { filteractionUuid })
}
